import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const FileV2 = (props: SvgIconT.Props) => (
  <SvgIcon width={24} {...props} viewBox="0 0 24 24">
    <path d="M16.5 8.5v1h-9v-1h9zm0 2v1h-9v-1h9zm-5 2v1h-4v-1h4zm7-8h-13v15h13v-15zm1-1v17h-15v-17h15z"></path>
  </SvgIcon>
);

export default FileV2;
